import React, { useState } from "react";
import Logo from "../../images/upsla-logo.png";
import LogoDark from "../../images/upsla-logo.png";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { adminLoginAPI } from "../../api/auth";
import { toast } from "react-toastify";
import { formatApiErrorMessage } from "../../utils/Utils";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
const navigate= useNavigate()
const onFormSubmit = async (data) => {
    try {
     
      setLoading(true);
     

      const myKey = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
      const body = {
        username: data.name,
        password: data.passcode,
        // os: os,
        // browser: browserName,
        // ip: ipAddress,
        // magic: encrypt(myKey),
      };

      // const encryptedData = encrypt(body);
      // const encryptData = {
      //   zero: encryptedData,
      // };
      // localStorage?.setItem("type", watch("type"));
      // const url = watch("type") == "admin" ? "login" : watch("type") == "lms_admin" ? "lms-login" : null;

      adminLoginAPI(body)
        .then((res) => {
          const status =  (res.data.status);
          console.log("okoko",res.data);
          
          const decryptedResponse =  (res.data);
          if (status === true) {
            localStorage.setItem("accessToken", decryptedResponse.access_token); 
            localStorage.setItem("userDetail", JSON.stringify(decryptedResponse?.user));
            toast.success(res.data.message);
            navigate("/dashboard");
          } else if (status === false) {
            toast.error(res.data.message); 
            setLoading(false);
          } else {
            toast.warning("unauthorized access!");
          }
        })
        .catch((err) => {
          setLoading(false); 
          toast.error(formatApiErrorMessage(err.response?.data) || err.message || "Login failed");
        });
    } catch (error) {
      setLoading(false); 
    } finally {
      setLoading(false);
    }
  };


  const {  register, handleSubmit, formState: { errors } } = useForm();

  return <>
    <Head title="Login" />
      <Block className="nk-block-middle nk-auth-body  wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
            <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
          </Link>
        </div>

        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Sign-In</BlockTitle>
              <BlockDes>
                <p>Access UPSLA- Admin Panel using your email and password.</p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          {errorVal && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> Unable to login with credentials{" "}
              </Alert>
            </div>
          )}
          <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="default-01">
                  Email or Username
                </label>
              </div>
              <div className="form-control-wrap">
                <input
                  type="text"
                  id="default-01"
                  {...register('name', { required: "This field is required" })}
                  // defaultValue="admin"
                  placeholder="Enter your email address or username"
                  className="form-control-lg form-control" />
                {errors.name && <span className="invalid">{errors.name.message}</span>}
              </div>
            </div>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
                {/* <Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                  Forgot Code?
                </Link> */}
              </div>
              <div className="form-control-wrap">
                <a
                  href="#password"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setPassState(!passState);
                  }}
                  className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                >
                  <Icon name="eye" className="passcode-icon icon-show"></Icon>

                  <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                </a>
                <input
                  type={passState ? "text" : "password"}
                  id="password"
                  {...register('passcode', { required: "This field is required" })}
                  // defaultValue="Admin@123"
                  placeholder="Enter your password"
                  className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`} />
                {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
              </div>
            </div>
            <div className="form-group">
              <Button size="lg" className="btn-block" type="submit" color="primary">
                {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
              </Button>
            </div>
          </Form>
          
           
          
        </PreviewCard>
      </Block>
      <AuthFooter />
  </>;
};
export default Login;